import {ERROR_MESSAGES, extendBeforeDate, extensionLimitDays, viewDocument} from "../../../helpers/data-constants";

export const headersClientContractTable = [
    { key: 'division', label: 'Подразделение' },
    { key: 'title', label: 'Название' },
    { key: 'model', label: 'Модель' },
    { key: 'weight', label: 'Вес, г.' },
    {
        key: 'contract_status',
        label: 'Статус договора',
    },
    {
        key: 'contract_type',
        label: 'Тип договора',
    },
    {
        key: 'loan_period',
        label: 'Срок предоставления займа',
    },
    {
        key: 'loan_amount',
        label: 'Сумма микрозайма, руб.',
    },
    {
        key: 'loan_percent',
        label: 'Процент займа',
    },
    {
        key: 'penalty_percent',
        label: 'Процент неустойки',
    },
    {
        key: 'redemption_amount',
        label: 'Сумма на выкуп, руб.',
    }
];

export const getClientContractConditions = ({
    selectedDeals,
    view,
    isProlongFeatureActive,
    userInfo,
    dataActiveCashbox,
    viewCloseProlongParam,
    validateProlongDeal,
    validateClientId,
    isProlongAnnuity,
    hasMultipleLongTermDeals,
    containsProlongLimitDaysDeal,
    isExtensionThreeImplementaition,
    isNewGlobalProlong,
    containsNotActiveNotProlong,
    containsNotActiveNotExpiredNotRetention,
    listRoles,
    containsDifferentDealDurationTypes,
    hasAnyShortTermDeal
  }) => [
    { 
      check: () => validateProlongDeal({ deals: selectedDeals, view }),
      message: extendBeforeDate,
    },
    { 
      check: () => validateClientId(viewCloseProlongParam),
    },
    {
      check: () => isProlongAnnuity(selectedDeals) && view === viewDocument.isProlong,
      message: 'Долгосрочный договор не может быть продлен'
    },
    {
      check: () => hasMultipleLongTermDeals(selectedDeals),
      message: 'Нельзя внести платеж по двум и более долгосрочным договорам одновременно'
    },
    {
      check: () => view === viewDocument.isProlong && isProlongFeatureActive && 
                  containsProlongLimitDaysDeal({ selectedDeals, isNewGlobalProlong, isExtensionThreeImplementaition }),
      message: extensionLimitDays
    },
    {
      check: () => (view === viewDocument.isProlong || view === viewDocument.isClosed) && 
                  containsNotActiveNotExpiredNotRetention(selectedDeals),
      message: 'Выбранный список содержит неактивные договоры',
    },
    {
      check: () => view === viewDocument.isToTransfer && containsNotActiveNotProlong(selectedDeals),
      message: 'Выбранный список содержит неактивные договоры или договор в статусе "Удержание"'
    },
    {
      check: () => view === viewDocument.isToTransfer &&
                  userInfo.roles.length === 1 &&
                  userInfo.roles.includes(listRoles.GOODS_SPECIALIST) &&
                  selectedDeals.length !== selectedDeals.filter(({ cashBoxId }) => cashBoxId === dataActiveCashbox.value).length,
      message: 'Выбранный список содержит договора из другого подразделения',
    },
    {
        check: () => view === viewDocument.isClosed && containsDifferentDealDurationTypes(selectedDeals),
        message: ERROR_MESSAGES.INVALID_CONTRACTS
    },
    {
        check:() => view === viewDocument.isPayAnnuity && hasAnyShortTermDeal(selectedDeals),
        message: ERROR_MESSAGES.INVALID_CONTRACTS
    }
  ];